import React, { Component } from "react";
import PropTypes from "prop-types";
import { StyleSheet } from "react-native";
import { translate } from "../../locales/translate";
import Theme from "../../argon-ui/Theme";
import { ArButton } from "../../argon-ui";
import { HStack } from "native-base";
import { getDir } from "../../util";
const LOADING_TIME = 4000;
class RBSheetInnerBatchAction extends Component {
  static propTypes = {
    deviceTypeName: PropTypes.string,
    turnOnAllText: PropTypes.string,
    turnOffAllText: PropTypes.string,
    showTurnOnAll: PropTypes.bool,
    showTurnOffAll: PropTypes.bool,
    onTurnOnAllPress: PropTypes.func,
    onTurnOffAllPress: PropTypes.func,
  };
  constructor(props) {
    super(props);
    this.state = {
      loadingTurnOnAll: false,
      loadingTurnOffAll: false,
      disabledTurnOnAll: false,
      disabledTurnOffAll: false,
    };
  }
  handleTurnOnAll = () => {
    this.setState(
      {
        loadingTurnOnAll: true,
        disabledTurnOffAll: true,
      },
      () => {
        this.props.onTurnOnAllPress();
        setTimeout(() => {
          this.setState({
            loadingTurnOnAll: false,
            disabledTurnOffAll: false,
          });
        }, LOADING_TIME);
      }
    );
  };
  handleTurnOffAll = () => {
    this.setState(
      {
        loadingTurnOffAll: true,
        disabledTurnOnAll: true,
      },
      () => {
        this.props.onTurnOffAllPress();
        setTimeout(() => {
          this.setState({
            loadingTurnOffAll: false,
            disabledTurnOnAll: false,
          });
        }, LOADING_TIME);
      }
    );
  };

  render() {
    return (
      <HStack space="2" p="2" style={{ direction: getDir() }}>
        {this.props.showTurnOnAll != false && (
          <ArButton
            variant="outline"
            isDisabled={this.state.disabledTurnOnAll}
            onPress={this.handleTurnOnAll}
            style={styles.btn}
            isLoading={this.state.loadingTurnOnAll}
          >
            {this.props.turnOnAllText || translate("scenario.TurnOnAll")}
          </ArButton>
        )}

        {this.props.showTurnOffAll != false && (
          <ArButton
            variant="outline"
            isDisabled={this.state.disabledTurnOffAll}
            onPress={this.handleTurnOffAll}
            style={styles.btn}
            isLoading={this.state.loadingTurnOffAll}
          >
            {this.props.turnOnAllText || translate("scenario.TurnOffAll")}
          </ArButton>
        )}
      </HStack>
    );
  }
}

const styles = StyleSheet.create({
  btn: {
    flex: 1,
    height: 40,
  },
  bottomSheetBatch: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    //backgroundColor: "#d5d5d5",
    height: 60,
    margin: 10,
    marginVertical: 0,
    borderBottomColor: "#d5d5d5",
    borderBottomWidth: 1,
  },
  bottomSheetBatchItem: {
    flex: 1,
    alignItems: "center",
    justifyContent: "space-between",
  },
  bottomSheetBatchButton: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Theme.COLORS.TL_PURPLE,
    borderRadius: 5,
    width: "90%",
    paddingHorizontal: 15,
    paddingVertical: 10,

    shadowColor: Theme.COLORS.SECONDARY,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 5,
  },
  bottomSheetBatchButtonText: {
    color: Theme.COLORS.WHITE,
    fontWeight: "bold",
  },
});
export default RBSheetInnerBatchAction;
